function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.972,13.031a4.622,4.622,0,0,1,1.86-3.711.479.479,0,0,0,.067-.69A4.948,4.948,0,0,0,15.457,7h0c-1.621-.153-3.165.959-3.989.959S9.3,7,7.957,7A5.121,5.121,0,0,0,3.633,9.646c-1.841,3.2-.47,7.9,1.275,10.529.873,1.266,1.918,2.695,3.3,2.647s1.822-.853,3.424-.853,2.052.853,3.452.825,2.369-1.295,3.251-2.56a11.728,11.728,0,0,0,1.314-2.56.479.479,0,0,0-.221-.585,4.565,4.565,0,0,1-2.455-4.056Z",
  transform: "translate(-2.757 -0.823)",
  fill: "#39a95e"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.859,4.022a5.025,5.025,0,0,0,1.17-2.963A.479.479,0,0,0,15.453.57a5.13,5.13,0,0,0-2.695,1.6,4.862,4.862,0,0,0-1.2,2.877.479.479,0,0,0,.527.489A4.3,4.3,0,0,0,14.859,4.022Z",
  transform: "translate(-3.118 -0.56)",
  fill: "#39a95e"
});

var SvgIosDeveloper = function SvgIosDeveloper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.92,
    height: 22.5,
    viewBox: "0 0 16.92 22.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIosDeveloper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ios_developer.479e3ced.svg";
export { ForwardRef as ReactComponent };